import { browserHistory } from '@utils/browserHistory.utils'
import { isInsidePaymentFlow } from '@utils/isInsidePaymentFlow.utils'
import React, { useState, useCallback, useEffect, ReactNode } from 'react'
import { useGetUser } from '@hooks/useAuth'
import { CarpayPaymentFlow } from '@customTypes/carpayPaymentFlow.interface'
import {
    SESSION_STORAGE_getCarpayPaymentFlow,
    SESSION_STORAGE_setCarpayPaymentFlow,
    SESSION_STORAGE_emptyCarpayPaymentFlow
} from '@sessionStorage/carpayPaymentFlow.sessionStorage'
import CarpayPaymentFlowContext from './CarpayPaymentContext'
import { Location } from 'history'

const CarpayPaymentFlowProvider = ({ children }: { children: ReactNode }) => {
    const userData = useGetUser()

    const userEmail = userData?.user?.email ?? ''

    const [state, setState] = useState<CarpayPaymentFlow>(() => {
        const savedState = SESSION_STORAGE_getCarpayPaymentFlow()
        if (savedState) return savedState

        return {
            parkingContextUuid: null,
            parkingTariff: null,
            email: userData?.user?.email ?? ''
        }
    })

    const updateState = (newState: Partial<typeof state>) => {
        setState((prev) => ({ ...prev, ...newState }))
    }

    const cleanState = useCallback(() => {
        setState({
            parkingContextUuid: null,
            parkingTariff: null,
            email: userEmail
        })

        SESSION_STORAGE_emptyCarpayPaymentFlow()
    }, [userEmail])

    useEffect(() => {
        SESSION_STORAGE_setCarpayPaymentFlow(state)
    }, [state])

    useEffect(() => {
        const clearBasedOnRoutePathname = (location: Location<unknown>) => {
            const nextPath = location.pathname.split('/').pop() ?? ''

            if (!isInsidePaymentFlow(nextPath)) {
                cleanState()
            }
        }

        const unlisten = browserHistory.listen(clearBasedOnRoutePathname)

        return () => {
            unlisten()
        }
    }, [cleanState])

    return (
        <CarpayPaymentFlowContext.Provider value={{ state, updateState }}>{children}</CarpayPaymentFlowContext.Provider>
    )
}

export default CarpayPaymentFlowProvider
